module.exports = __webpack_public_path__ + "static/media/4.d1b34612.png";